// Returns true if the string contains any Cyrillic character. The previous
// implementation required the *entire* message to match a strict allowlist of
// letters, digits, and a small set of punctuation — so a perfectly normal
// Cyrillic sentence with "!" or "?" was misclassified as a translation key
// and ran through i18next's namespace lookup, which can surface the wrong
// text (or a missing-key fallback) in user-facing toasts.
const isCyrillic = (message) =>
  typeof message === 'string' && /[Ѐ-ӿ]/.test(message);

export default isCyrillic;
